import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessageEmpty = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.7748 10.7369C0.75 9.89117 0.75 9.25128 0.75 6.52778C0.75 3.80428 0.75 2.44217 1.7748 1.59644C2.801 0.75 4.4502 0.75 7.75 0.75C11.0498 0.75 12.6997 0.75 13.7245 1.59644C14.7493 2.44289 14.75 3.80428 14.75 6.52778C14.75 9.25128 14.75 9.89117 13.7245 10.7369C12.7004 11.5833 11.0498 11.5833 7.75 11.5833C5.993 11.5833 5.09 12.8386 3.55 13.75V11.4302C2.7842 11.3125 2.2207 11.1052 1.7748 10.7369Z",
		stroke: "#3D70B2",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgMessageEmpty);
export { ForwardRef as ReactComponent };
